var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldenStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6572 5.71875C10.7911 6.13077 11.1752 6.41015 11.6084 6.41016H16.9717L12.6328 9.5625C12.2823 9.81715 12.1357 10.2687 12.2695 10.6807L13.9268 15.7812L9.58789 12.6289C9.2374 12.3743 8.7626 12.3743 8.41211 12.6289L4.07324 15.7812L5.73047 10.6807C5.86434 10.2687 5.71765 9.81715 5.36719 9.5625L1.02832 6.41016H6.3916C6.82482 6.41015 7.2089 6.13077 7.34277 5.71875L9 0.618164L10.6572 5.71875Z",
    fill: "white",
    stroke: "#EE7233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenStar);
export default __webpack_public_path__ + "static/media/golden_star.9e4cd7097401d7094d37360677d5753a.svg";
export { ForwardRef as ReactComponent };